import ToastHighLighter from '@/lib/ToastHighLighter';

export const StandardFormCode = () => {
  const language = 'html';
  const codeString = `
  // Standard Form
  <form noValidate="true" method="" id="bootstrapForm02">
    <div class="mb-3">
      <label htmlFor="exampleInputEmail1" class="form-label">
        Email address
      </label>
      <input
        type="email"
        class="form-control"
        id="exampleInputEmail1"
        aria-describedby="emailHelp"
        placeholder="E-Mail"
      />
      <div id="emailHelp" class="form-text">
        We'll never share your email with anyone else.
      </div>
      <label htmlFor="exampleInputPassword1" class="form-label">
        Text
      </label>
      <input
        type="text"
        class="form-control"
        id="exampleInputPassword1"
        autoComplete="on"
      />
    </div>

    <div class="my-3">
      <label htmlFor="inputPassword5" class="form-label">
        Password
      </label>
      <input
        type="password"
        id="inputPassword5"
        class="form-control"
        aria-describedby="passwordHelpBlock"
        autoComplete="on"
      />
      <div id="passwordHelpBlock" class="form-text">
        Your password must be 8-20 characters long, contain letters and
        numbers, and must not contain spaces, special characters, or emoji.
      </div>
    </div>

    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="exampleCheck1"
        required
        />
        <label className="form-check-label" htmlFor="exampleCheck1">
        Accept terms & conditions
        </label>
        </div>
        
        <div className="form-check mb-4">
        <input
        type="checkbox"
        className="form-check-input"
        id="exampleCheck2"
        required
        />
      <label className="form-check-label" htmlFor="exampleCheck2">
        Check me out
      </label>
    </div>

    <button
      id="resetForm"
      type="submit"
      class="btn btn-secondary me-2"
    >
      Submit
    </button>
    <button id="resetForm" class="btn btn-light" type="reset">
      Reset form
    </button>
  </form>
  `;

  return (
    <>
      <ToastHighLighter
        name={'form'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const FormValidationJSCode = () => {
  const language = 'js';
  const codeString = `
  // Form validation - Javascript example code
  
  (function () {
    'use strict';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        'submit',
        function (event) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add('was-validated');
        },
        false
      );
    });
  })();  
`;

  return (
    <>
      <ToastHighLighter
        name={'formvalidationjs'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
